"use client";

import { useEffect, useState, type PropsWithChildren } from "react";
import { useRouter } from "next/navigation";
import { authHelpers } from "@/lib/api";

/**
 * Prevent rendering of auth pages for authenticated users.
 * Synchronous check (localStorage/cookie) avoids flicker on client navigation.
 */
export default function NoAuthGuard({ children }: PropsWithChildren) {
  const router = useRouter();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // Synchronous check: localStorage OR cookie (cookie may be present when localStorage isn't)
    const token = authHelpers.getToken?.() ?? null;
    const cookieToken = typeof document !== 'undefined' && document.cookie.includes('authToken=') ? 'present' : null;

    if (token || cookieToken) {
      // Replace to avoid navigation history entry and visual flicker
      router.replace("/");
      return;
    }

    setChecked(true);
  }, [router]);

  if (!checked) return null;

  return <>{children}</>;
}
